import { render, staticRenderFns } from "./CardMensagensCliente.vue?vue&type=template&id=2e18e41a&"
import script from "./CardMensagensCliente.vue?vue&type=script&lang=js&"
export * from "./CardMensagensCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports